import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { gql, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";

export const FRAGMENT_UNITS = new FragmentDefiner(
	"Property",
	`
  project {
    commercial_units {
      id
      code
      link
      title
      bedrooms
      bathrooms
	  m2
	  m2Terrace
      price {
        currency {
          name
        }
        amount
      }
    }
  }
`
);

const SEND_LEAD_MUTATION = gql`
	mutation sendLead($input: LeadInput!) {
		sendLead(input: $input) {
			id
		}
	}
`;

interface ContactInput {
	property_id: number;
	source: number;
	type: string;
	financing_information: boolean;
	message?: string;
	visit_type?: string;
	date?: string;
	utm_args?: UtmArgs;
	isAutoGenerated?: boolean;
}

interface UtmArgs {
	utm_content?: string | string[];
	utm_source?: string | string[];
	utm_medium?: string | string[];
	utm_campaign?: string | string[];
}

export const useUnits = ({ comertialUnits, utm = null }) => {
	const [filters, setFilters] = useState([]);
	const [units, setUnits] = useState([]);
	const [sendLeadMutation] = useMutation(SEND_LEAD_MUTATION, {
		onError: error => {
			console.log("Error Ask Availabilty Unit", error);
		},
	});

	useEffect(() => {
		if (comertialUnits) {
			let newFilters = [];
			for (const newUnit of comertialUnits) {
				let filterIndex = newFilters.findIndex(unit => unit.beds == newUnit.bedrooms);
				if (filterIndex > -1) {
					newFilters[filterIndex].units.push(newUnit);
				} else {
					newFilters.splice(newUnit.bedrooms, 0, {
						beds: newUnit.bedrooms,
						units: [newUnit],
					});
				}
			}
			setFilters(newFilters);
			setUnits(comertialUnits);
		}
	}, [comertialUnits]);

	const sendLead = async unitID => {
		let input : ContactInput = {
			type: "PROPERTY",
			property_id: unitID,
			message: "dispositionID",
			source: 14,
			isAutoGenerated: true,
			financing_information: false,
		};

		if(utm && (utm.utm_campaign || utm.utm_content || utm.utm_medium || utm.utm_source)){
			input.utm_args = {};
			if(utm.utm_campaign){
				input.utm_args.utm_campaign = utm.utm_campaign;
			}
			if(utm.utm_content){
				input.utm_args.utm_content = utm.utm_content;
			}
			if(utm.utm_medium){
				input.utm_args.utm_medium = utm.utm_medium;
			}
			if(utm.utm_source){
				input.utm_args.utm_source = utm.utm_source;
			}
		}

		return sendLeadMutation({
			variables: {
				input
			},
		});
	};

	return {
		filters,
		units,
		sendLead,
	};
};
